var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useEffect, useState, useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { FaChevronDown } from 'react-icons/fa';
import { useLanguage } from '@base/LanguageProvider';
import { EntityPermissionsType, TagType, } from '@common/api';
import Manager from '@shared/modal/Manager';
import { ContextMenu } from '@shared/contextmenu';
import ShareModal from '@shared/finder/modals/ShareModal';
import DeleteTagModal from '@shared/finder/modals/DeleteTag';
import * as FarseerIcons from '@shared/icons/icons';
import { useOutsideClick } from '@hooks/useOutsideClick';
import { useTagActions } from '@data/tag/tagActions';
import { TagQueryKeys } from '@data/tag/types';
import useTheme from '@styled/useTheme';
import { BtnFlex } from '@styled/Button';
import { FlexRow } from '@styled/FlexWrappers';
import { TETableTab, TETagInput } from '@styled/TagEditor';
import { calculateTagPerms } from './permissions';
export function TableTabs(_a) {
    var e_1, _b;
    var _c;
    var selectedGroupId = _a.selectedGroupId, selectedTableId = _a.selectedTableId, canAddTables = _a.canAddTables, tagsByParentId = _a.tagsByParentId, addTableTag = _a.addTableTag, selectTableHandler = _a.selectTableHandler, tagClassActions = _a.tagClassActions, tagActionsMap = _a.tagActionsMap, allGroups = _a.allGroups, changeTagParent = _a.changeTagParent, newlyAdded = _a.newlyAdded, resetNewlyAdded = _a.resetNewlyAdded;
    var L = useLanguage().L;
    var theme = useTheme();
    var children = (_c = tagsByParentId["".concat(selectedGroupId)]) !== null && _c !== void 0 ? _c : [];
    var tables = [];
    var accounts = [];
    try {
        for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
            var ch = children_1_1.value;
            switch (ch.type) {
                case TagType.Table:
                    tables.push(ch);
                    break;
                case TagType.Account:
                    accounts.push(ch);
                    break;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (children_1_1 && !children_1_1.done && (_b = children_1.return)) _b.call(children_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    tables.sort(function (a, b) { return a.order - b.order; });
    var selectHanlder = function (tableId) {
        selectTableHandler(tableId, selectedGroupId);
    };
    return (React.createElement(FlexRow, { style: { padding: '0px 10px', minHeight: '36px', overflow: 'overlay' } },
        accounts.length > 0 && (React.createElement(TableTabsTab, { key: "acc", active: selectedTableId === 0, tabName: L('Variables'), isAccount: true, selectTableTag: selectHanlder, tagClassActions: tagClassActions, tagActionsMap: tagActionsMap, allGroups: allGroups, changeTagParent: changeTagParent, isNewTag: false, resetNewlyAdded: resetNewlyAdded })),
        tables.map(function (table) {
            return (React.createElement(TableTabsTab, { key: "table-".concat(table.id), active: selectedTableId === table.id, table: table, tabName: table.name, selectTableTag: selectHanlder, tagClassActions: tagClassActions, tagActionsMap: tagActionsMap, allGroups: allGroups, changeTagParent: changeTagParent, isNewTag: newlyAdded === (table === null || table === void 0 ? void 0 : table.id), resetNewlyAdded: resetNewlyAdded }));
        }),
        canAddTables ? (React.createElement(BtnFlex, { onClick: function () { return addTableTag(); } },
            React.createElement(FarseerIcons.Plus, { color: theme.colors.primary.w500 }))) : null));
}
function TableTabsTab(_a) {
    var _this = this;
    var _b;
    var table = _a.table, active = _a.active, tabName = _a.tabName, selectTableTag = _a.selectTableTag, _c = _a.isAccount, isAccount = _c === void 0 ? false : _c, tagClassActions = _a.tagClassActions, tagActionsMap = _a.tagActionsMap, allGroups = _a.allGroups, changeTagParent = _a.changeTagParent, isNewTag = _a.isNewTag, resetNewlyAdded = _a.resetNewlyAdded;
    var L = useLanguage().L;
    var queryClient = useQueryClient();
    var editTag = useTagActions().editTag;
    var _d = __read(useState(false), 2), isEditing = _d[0], setIsEditing = _d[1];
    var _e = __read(useState(''), 2), tagName = _e[0], setTagName = _e[1];
    var menuTriggerRef = useRef(null);
    var elRef = useRef(null);
    var inputRef = useRef(null);
    var cancelEditing = function () {
        setIsEditing(false);
        resetNewlyAdded();
    };
    var wrapRef = useRef(null);
    useOutsideClick(wrapRef, cancelEditing, !isEditing);
    useEffect(function () {
        if (!active && isEditing) {
            setIsEditing(false);
        }
    }, [active]);
    var _f = calculateTagPerms(tagClassActions, tagActionsMap, table), canEdit = _f.canEdit, canDelete = _f.canDelete;
    useEffect(function () {
        if (isNewTag) {
            startEditing(true);
        }
    }, [isNewTag]);
    var startEditing = function (selectAll) {
        if (selectAll === void 0) { selectAll = false; }
        if (table) {
            setTagName(table.name);
            setIsEditing(true);
            if (selectAll) {
                setTimeout(function () {
                    var _a, _b, _c;
                    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.select();
                    (_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.setSelectionRange(0, table.name.length);
                }, 20);
            }
        }
    };
    var keyDownHandler = function (e) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(table && e.key === 'Enter')) return [3 /*break*/, 2];
                    return [4 /*yield*/, editTag(__assign(__assign({}, table), { name: tagName })).catch(function (e) {
                            toast.error('Table ' + e.message);
                            return;
                        })];
                case 1:
                    _a.sent();
                    queryClient.invalidateQueries(TagQueryKeys.Tags);
                    setTagName('');
                    setIsEditing(false);
                    resetNewlyAdded();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var moveToOptions = useMemo(function () {
        var arr = [
            {
                actionName: 'Root',
                isDisabled: !canEdit,
                action: function () { return (table ? changeTagParent(table === null || table === void 0 ? void 0 : table.id, null) : null); },
            },
        ];
        allGroups.forEach(function (group) {
            var targetParentTagPerms = calculateTagPerms(tagClassActions, tagActionsMap, group);
            if (targetParentTagPerms.canEdit) {
                arr.push({
                    actionName: group.name,
                    isDisabled: !canEdit,
                    action: function () { return (table ? changeTagParent(table === null || table === void 0 ? void 0 : table.id, group.id) : null); },
                });
            }
        });
        return arr;
    }, [allGroups]);
    return (React.createElement(TETableTab, { "$acc": isAccount, "$active": active, "$editing": isEditing, onClick: function () { return (isAccount ? selectTableTag(0) : selectTableTag(table === null || table === void 0 ? void 0 : table.id)); }, ref: wrapRef },
        React.createElement("div", { ref: elRef, className: isEditing ? 'invisible-width-holder' : '' },
            React.createElement("span", { style: { padding: active && table ? '0px' : '0px 7.5px' } }, tabName),
            active && table && (React.createElement(React.Fragment, null,
                React.createElement("span", { style: { paddingLeft: '5px', paddingTop: '3px', fontSize: '10px', cursor: 'pointer' }, ref: menuTriggerRef },
                    React.createElement(FaChevronDown, null)),
                React.createElement(ContextMenu, { items: [
                        {
                            icon: FarseerIcons.Edit,
                            actionName: L('Rename Table'),
                            isDisabled: !canEdit,
                            action: function () { return startEditing(false); },
                        },
                        {
                            icon: FarseerIcons.ArrowRight,
                            actionName: L('Move to'),
                            isDisabled: !canEdit,
                            items: moveToOptions,
                        },
                        {
                            icon: FarseerIcons.Share,
                            actionName: L('Share Table'),
                            isDisabled: !canEdit,
                            action: function () {
                                Manager.renderModal(React.createElement(ShareModal, { targetId: table.id, entity: EntityPermissionsType.Tag }));
                            },
                        },
                        { spacer: true },
                        {
                            icon: FarseerIcons.Delete,
                            actionName: L('Delete'),
                            isDisabled: !canDelete,
                            destructive: true,
                            items: [
                                {
                                    icon: FarseerIcons.DeleteTagData,
                                    actionName: L('Delete Table Data'),
                                    isDisabled: !canDelete,
                                    destructive: true,
                                    action: function () {
                                        Manager.renderModal(React.createElement(DeleteTagModal, { target: table, deleteType: "data" }));
                                    },
                                },
                                {
                                    icon: FarseerIcons.DeleteChildTags,
                                    actionName: L('Delete Table Dimensions'),
                                    isDisabled: !canDelete,
                                    destructive: true,
                                    action: function () {
                                        Manager.renderModal(React.createElement(DeleteTagModal, { target: table, deleteType: "children" }));
                                    },
                                },
                                { spacer: true },
                                {
                                    icon: FarseerIcons.Delete,
                                    actionName: L('Delete Table'),
                                    isDisabled: !canDelete,
                                    destructive: true,
                                    action: function () {
                                        Manager.renderModal(React.createElement(DeleteTagModal, { target: table, deleteType: "tag" }));
                                    },
                                },
                            ],
                        },
                    ], triggerRefs: [{ ref: menuTriggerRef, trigger: 'click' }] })))),
        isEditing ? (React.createElement(TETagInput, { ref: inputRef, autoFocus: true, autoComplete: "on", type: "text", value: tagName, name: "tag", onChange: function (e) { return setTagName(e.target.value); }, onKeyDown: keyDownHandler, style: {
                width: elRef && elRef.current ? ((_b = elRef === null || elRef === void 0 ? void 0 : elRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth) + 'px' : '100px',
            } })) : null));
}
